import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { ICompany, IPartnerSlim, IResponseWithLoading } from "App/Modules/Models";
import type { ICompaniesRepository, IPartnersRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";

import { head } from "lodash";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class AddCompanyComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmCompaniesRepository", "mmPartnersRepository"];

    public resolve: IFormContainerResolve<ICompany, void>;

    public company: ICompany;

    public addCompanyResponse: IResponseWithLoading<ICompany>;

    public partners: IPartnerSlim[];

    public partnersResponse: IResponseWithLoading<IPartnerSlim[]>;

    constructor(
        private readonly $scope: IScope,
        private readonly companiesRepository: ICompaniesRepository,
        private readonly partnersRepository: IPartnersRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.partnersRepository.getPartners())
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response) => {
                    this.partnersResponse = response;
                    if (!response.isLoading && response.data && response.data.length === 1) {
                        this.company = {} as ICompany;
                        this.company.partner = head(response.data);
                    }
                },
                (error) => {
                    this.partnersResponse = error;
                },
            );
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public addCompany() {
        extendWithLoadingAndFail(this.companiesRepository.addCompany(this.company))
            .pipe(
                finalize(() => {
                    this.$scope.$applyAsync();
                }),
            )
            .subscribe(
                (company) => {
                    this.addCompanyResponse = company;
                    if (!company.isLoading && company.data) {
                        this.resolve.options.onOk(company.data);
                    }
                },
                (error) => {
                    this.addCompanyResponse = error;
                },
            );
    }
}
